const HttpStatus = {
    OK: 200,
    Created: 201,
    Accepted: 202,
    NoContent: 204,
    MultipleChoice: 300,
    MovedPermanently: 301,
    Found: 302,
    NotModified: 304,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    NotAuthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    URITooLong: 414,
    UnsupportedMediaType: 415,
    ExpectationFailed: 416,
    ImATeapot: 418,
    UnprocessableEntity: 422,
    RefreshTokenRequired: 425,
    TooManyRequests: 429,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HTTPVersionNotSupported: 505,
    NetworkAuthenticationRequired: 511,

    isServerErrorResponse: (code) => code >= 500,
    isClientErrorResponse: (code) => code >= 400 && code < 500,
    isRedirectionMessage: (code) => code >= 300 && code < 400,
    isSuccessfulResponse: (code) => code >= 200 && code < 300,
    isInformationResponse: (code) => code >= 100 && code < 200,
};

export default HttpStatus;